import { render, staticRenderFns } from "./MammalsList.vue?vue&type=template&id=10e73b13&scoped=true&"
import script from "./MammalsList.vue?vue&type=script&lang=js&"
export * from "./MammalsList.vue?vue&type=script&lang=js&"
import style0 from "./MammalsList.vue?vue&type=style&index=0&id=10e73b13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e73b13",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCol,VDataTable,VIcon})
